import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

const NO_REFRESH = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/google/session"];
let refreshing = null;
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export function refreshSession() {
  if (!refreshing) {
    refreshing = axios
      .post(`${API}/auth/refresh`, {}, { withCredentials: true })
      .finally(() => {
        refreshing = null;
      });
  }
  return refreshing;
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    if (!config) return Promise.reject(error);
    const url = config.url || "";
    if (!error.response) {
      const attempt = (config._netRetry || 0) + 1;
      if ((config.method || "get") === "get" && attempt <= 3) {
        config._netRetry = attempt;
        await sleep(700 * attempt);
        return api(config);
      }
      return Promise.reject(error);
    }
    if (
      error.response.status === 401 &&
      !config._retried &&
      !NO_REFRESH.some((path) => url.includes(path))
    ) {
      config._retried = true;
      try {
        await refreshSession();
        return api(config);
      } catch (refreshError) {
        if (refreshError?.response?.status === 401) {
          window.dispatchEvent(new CustomEvent("nexreq:session-expired"));
        }
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  },
);

export function apiErr(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export default api;
